import i18n from '@/locales'
export const actionMap = {
  DELETE: i18n.t('bill.text_167'),
}

export const resSidepageMap = {
  DISK_UNUSED: {
    initSidePageTab: 'disk-detail',
    sidePageTriggerHandle: 'DiskSidePage',
    resource: 'disks',
  },
  EIP_UNUSED: {
    initSidePageTab: 'eip-detail',
    sidePageTriggerHandle: 'EipSidePage',
    resource: 'eips',
  },
  LB_UNUSED: {
    initSidePageTab: 'lb-detail',
    sidePageTriggerHandle: 'LbSidePage',
    resource: 'loadbalancers',
  },
  SCALE_DOWN: {
    initSidePageTab: 'vm-instance-detail',
    sidePageTriggerHandle: 'VmInstanceSidePage',
    resource: 'servers',
  },
  SNAPSHOT_UNUSED: {
    initSidePageTab: 'snapshot-detail',
    sidePageTriggerHandle: 'SnapshotSidePage',
    resource: 'snapshots',
  },
  TIMING_OPEN_SERVER: {
    initSidePageTab: 'vm-instance-detail',
    sidePageTriggerHandle: 'VmInstanceSidePage',
    resource: 'servers',
  },
  DOWN_SIZE: { // 建议降配的虚拟机
    initSidePageTab: 'vm-instance-detail',
    sidePageTriggerHandle: 'VmInstanceSidePage',
    resource: 'servers',
  },
  OSS_UNREASONABLE: { // 空闲的对象存储
    initSidePageTab: 'detail',
    sidePageTriggerHandle: 'BucketStorageSidePage',
    resource: 'buckets',
  },
  SECGROUPRULEINSERVER_ALLIN: { // 安全组规则的in规则为全开放的主机
    initSidePageTab: 'vm-instance-detail',
    sidePageTriggerHandle: 'VmInstanceSidePage',
    resource: 'servers',
  },
  OSS_SEC_ACL: { // 对象存储权限为开放读、写的存储桶
    initSidePageTab: 'detail',
    sidePageTriggerHandle: 'BucketStorageSidePage',
    resource: 'buckets',
  },
}

export const PROCESSING_METHODS = [
  { key: 'delete', value: i18n.t('bill.text_167') },
  { key: 'ignore', value: i18n.t('bill.text_269') },
]
